"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformThumbnailsToJSON = exports.transformJSONToThumbnails = void 0;

require("core-js/modules/es.string.small.js");

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformThumbnailsToJSON = function transformThumbnailsToJSON(value) {
  return {
    small: value.small,
    medium: value.medium,
    large: value.large
  };
};

exports.transformThumbnailsToJSON = transformThumbnailsToJSON;

var transformJSONToThumbnails = function transformJSONToThumbnails(value) {
  return {
    small: value.small,
    medium: value.medium,
    large: value.large
  };
};
/**
 * Thumbnail image URLs in various sizes. The aspect ratio of the original image is preserved. If the width of original image is lower than the desired width then the original width is used.
 * @export
 * @interface Thumbnails
 */


exports.transformJSONToThumbnails = transformJSONToThumbnails;